import { Component, Input, ElementRef, OnInit, ViewChild } from "@angular/core";

import { Esignature } from "../../print/esign/esignature.component";
import { EsignService } from "../../print/esign/esign.service";
import { Signature } from "../../store/document/state";

const signatureScale = 1.8;

@Component({
    selector: "sign-modal",
    template: `
        <div class="mod mod-modal" [class.is-open]="isVisible">
            <div
                class="mod-modal__dialog mod-modal__dialog--large"
                style="touch-action: none"
            >
                <div *ngIf="signature" class="mod-modal__content">
                    <esignature
                        [field]="signature"
                        [signatureScale]="signatureScale"
                    ></esignature>
                </div>
                <div class="mod-modal__footer">
                    <button class="zas-button zas-zbd" (click)="reset()">
                        Löschen
                    </button>
                    <button class="zas-button zas-zbd" (click)="set()">
                        Übernehmen
                    </button>
                    <button class="zas-button zas-zbd" (click)="close()">
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    `,
    styleUrls: ["./zurich-style.css", "./zurich.css", "./main.css"],
    styles: [
        `
            button.zas-button.zas-zbd {
                min-width: 160px;
                max-width: 160px;
            }
        `,
    ],
})
export class SignModal {
    @ViewChild(Esignature) esignature: Esignature;

    signatureScale: number = signatureScale;
    isVisible = false;

    signature: Signature;

    constructor(private esignService: EsignService) {}

    public get hasSignature() {
        return this.signature && this.signature.dataUrl != null;
    }

    public open(signature: Signature): void {
        this.signature = signature;
        this.isVisible = true;

        // setTimeout(() => {
        //     if (this.signature.dataUrl != null && this.esignature) {
        //         this.esignature.setSignatureImage(this.signature.dataUrl)
        //     }
        // })
    }

    public close(): void {
        this.signature = null;
        this.isVisible = false;
    }

    public set(): void {
        this.esignService.sign(
            this.signature,
            this.esignature.getSignatureImage(),
        );
        this.close();
    }

    public reset(): void {
        this.esignature.reset();
        this.esignService.reset(this.signature);
        this.close();
    }
}
